import {
  Component, Input, OnInit
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { ActividadesMiEmpresaFormInput } from '../datos-mi-empresa.model';

@Component({
  selector: 'rpe-actividades-mi-empresa-form',
  templateUrl: './actividades-mi-empresa-form.component.html',
  styleUrls: ['./actividades-mi-empresa-form.component.css']
})
export class ActividadesMiEmpresaFormComponent implements OnInit {
  @Input()
  set formInput(actividadesMiEmpresaFormInput: ActividadesMiEmpresaFormInput) {}

  get formInput(): ActividadesMiEmpresaFormInput {
    return this._formInput;
  }

  _formInput: ActividadesMiEmpresaFormInput = null;
  actividadesMiEmpresaFormGroup: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {}
}
